<template>
  <div class="">

    <template v-if="opportunities == null"></template>

    <template v-else>

      <!-- <Filters v-bind:params="params"></Filters> -->

      <template v-if="opportunities.length == 0">
        <div class="text-center mt-12">
          <img src="/static/img/icons/icons8-unfriend_male_filled.png" style="width:50px;" />

          <div class="mt-4 text-lg font-thin text-gray-700">
            No opportunities found. 
          </div>
        </div>
      </template>

      <template v-else>

        <table class="bp-table">
          <thead>
            <tr class="border-b border-t">
              <th class="py-4 px-6 text-left border-r" style="width:200px;">
                Opportunity name

                <!-- <OrderByArrow 
                  v-bind:updateOrderBy="updateOrderBy"
                  orderKey="applicant_names"
                  orderKeyLabel="applicant name"
                  v-bind:orderBy="params.orderBy"
                  v-bind:orderType="params.orderType"></OrderByArrow> -->
              </th>
              <th class="py-4 px-6 text-left border-r">
                Applicants

                <!-- <OrderByArrow 
                  v-bind:updateOrderBy="updateOrderBy"
                  orderKey="applicant_names"
                  orderKeyLabel="applicant name"
                  v-bind:orderBy="params.orderBy"
                  v-bind:orderType="params.orderType"></OrderByArrow> -->
              </th>

              <th class="p-4 text-left border-r overflow-hidden">
                Created

                <!-- <OrderByArrow 
                  v-bind:updateOrderBy="updateOrderBy"
                  orderKey="applicant_emails"
                  orderKeyLabel="email"
                  v-bind:orderBy="params.orderBy"
                  v-bind:orderType="params.orderType"></OrderByArrow> -->
              </th>

              <th class="p-4 text-left border-r overflow-hidden">
                Updated

                <!-- <OrderByArrow 
                  v-bind:updateOrderBy="updateOrderBy"
                  orderKey="applicant_emails"
                  orderKeyLabel="email"
                  v-bind:orderBy="params.orderBy"
                  v-bind:orderType="params.orderType"></OrderByArrow> -->
              </th>

              <th class="p-4 text-left border-r overflow-hidden">
                Transaction type

                <!-- <OrderByArrow 
                  v-bind:updateOrderBy="updateOrderBy"
                  orderKey="applicant_emails"
                  orderKeyLabel="email"
                  v-bind:orderBy="params.orderBy"
                  v-bind:orderType="params.orderType"></OrderByArrow> -->
              </th>

              <th class="p-4 text-left border-r">
                Status

                <!-- <OrderByArrow 
                  v-bind:updateOrderBy="updateOrderBy"
                  orderKey="mobile_phones"
                  orderKeyLabel="mobile"
                  v-bind:orderBy="params.orderBy"
                  v-bind:orderType="params.orderType"></OrderByArrow> -->
              </th>

              <!-- <th class="p-4 text-left border-r">
                Last activity

                <OrderByArrow 
                  v-bind:updateOrderBy="updateOrderBy"
                  orderKey="last_activity_timestamp"
                  v-bind:orderBy="params.orderBy"
                  v-bind:orderType="params.orderType"></OrderByArrow>
              </th>

              <th class="py-4 pl-4 pr-3 text-left border-r">
                Status

                <OrderByArrow 
                  v-bind:updateOrderBy="updateOrderBy"
                  orderKey="status"
                  v-bind:orderBy="params.orderBy"
                  v-bind:orderType="params.orderType"></OrderByArrow>
              </th>

              <th class="p-4 text-left border-r">
                Login

                <OrderByArrow 
                  v-bind:updateOrderBy="updateOrderBy"
                  orderKey="client_token_created_at"
                  orderKeyLabel="login"
                  v-bind:orderBy="params.orderBy"
                  v-bind:orderType="params.orderType"></OrderByArrow>
              </th>

              <th class="p-4 text-center">
                Actions
              </th> -->
            </tr>
          </thead>
          <tbody>
            <Opportunity
              v-for="(opportunity, index) in opportunities"
              v-bind:opportunity="opportunity"
              v-bind:index="index"
              v-bind:key="opportunity.id">
            </Opportunity>
          </tbody>
        </table>

        <div class="my-6 flex justify-between">
          <div class="flex items-center">
            <v-pagination 
              v-if="numOpportunities > params.limit"
              v-model="currentPage"
              :page-count="Math.ceil(numOpportunities / params.limit)"
              :labels="customLabels" />
          </div>

          <div class="mr-4 text-gray-600">
            Found {{ numOpportunities }} {{ numOpportunities == 1 ? 'opportunity' : 'opportunities' }}
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
  import Opportunity    from "./Opportunity"
  import { EventBus }   from '@/shared/event-bus'
  import OrderByArrow   from '@/shared/components/OrderByArrow'
  import vPagination    from 'vue-plain-pagination'

  export default {

    components : {
      Opportunity,
      OrderByArrow,
      vPagination
    },

    data () {
      return {
        opportunities    : null,
        numOpportunities : null,
        
        currentPage : 1,
        customLabels: {
          first: false,
          prev: 'Previous',
          next: 'Next',
          last: false
        },
        
        selectedClient   : null,
        openClientActions: false,
        
        params           : {},
      }
    },

    watch: {
      '$route' : {
        immediate: true,
        handler  : function(to, from) {
          if(Object.keys(to.params).length == 0) {
            this.resetParams()
          }

          else {
            this.setParams(to.params)
          }

          this.getOpportunities()
        }
      },

      'currentPage' : {
        handler(to, from) {
          EventBus.$emit('param-changed', {
            key  : 'offset',
            value: this.params.limit * (to-1)
          })
        }
      }
    },

    mounted() {
      // EventBus.$on('open-client-actions', selectedClient => {
      //   this.openClientActions = true
      //   this.selectedClient    = selectedClient
      // });

      // EventBus.$on('close-client-actions', () => {
      //   this.openClientActions = false
      //   this.selectedClient    = null
      // });

      EventBus.$on('param-changed', keyValue => {
        this.params[keyValue.key] = keyValue.value
        this.$router.push({
          name   : 'opportunity-search',
          params : this.params
        });
      });

      EventBus.$on('reset-params', () => {
        this.resetParams()
        this.$router.push({
          name   : 'opportunity-search',
          params : this.params
        });
      });

      EventBus.$on('fetch-opportunities', () => {
        this.getOpportunities()
      });
    },

    methods: {

      setParams(params) {

        // this is when we landed on the page and then clicked on
        // any search params to start a search
        if(params && Object.keys(params).length > 0) {
          this.params = params
        }

        // this is when we land directly on a particular search params
        else if(Object.keys(this.$route.params).length > 0) {
          this.params = this.$route.params
        }
      },

      resetParams() {
        this.params = {
          query     : this.$store.state.emptyQueryIndicator,
          orderBy   : "id",
          orderType : "desc",
          limit     : 50,
          offset    : 0
        }
      },

      getOpportunities() {
        this.showLoader("Loading clients...")
        this.apiGet(this.params, 'mercury/mercury-opportunities', (data) => {
          this.hideLoader()
          this.opportunities    = data.opportunities
          this.numOpportunities = data.total
        })
      },

      // whenever someone clicks on the table header, we will update the ordering
      // of the table
      // But what if we clicked on the same header that we are already ordering by?
      // in that case, we are simply swapping from either ascending to descending or
      // vice versa
      updateOrderBy(orderBy) {
        if(this.params.orderBy == orderBy) {
          this.params.orderType = this.params.orderType == 'asc' ? 'desc' : 'asc'
        } else {
          this.params.orderBy = orderBy
        }

        this.getOpportunitiesAndUpdateRoute()
      },

      paginate(pageNum) {
        this.params.offset = this.params.limit * (pageNum-1)
        this.getOpportunitiesAndUpdateRoute()
      },

      // each time the search parameter changes
      // we need to update the params on the store
      // and also update the route to reflect the changes
      // so that whenever user refreshes the URL, they are
      // landed on the same page
      // This method is usually accessed from the client list page
      getOpportunitiesAndUpdateRoute() {

        // and let's refresh the route to reflect the new change
        this.$router.push({
          name   : 'opportunity-search',
          params : this.params
        });

        // let's re-fetch the clients
        this.getOpportunities()
      },
    }
  }
</script>